import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/auth";

export default function ProtectedRoute({ children }) {
  const { admin, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white/40">
        Checking session...
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }
  return children;
}
